import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewQuickStartService {
    companyDetailsCheck = new Subject<boolean>();
  constructor() { }
}
